import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List,
    API_PAYPAL,
    gAPI_Ingetration,
    gAPI_Rooms
} from '../../../../../constants/APIs';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import Validation from '../../../../../components/Validation';


let arr = [];
export default function PayPalIntegration({ visible, toggle, id, LoadIntegrations }) {
    const [property, setProperty] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [maskData, setMaskData] = useState({
        clientID: ""
    });
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: '',
        Properties: [],
        SessionTimeoutInSeconds: 600,
        DefaultLanguage: 'en-US',
        clientID: '',
    });
    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${API_PAYPAL}/${id}?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setInputData({
                        ...inputData,
                        Name: res.data.name,
                        Properties: res.data.properties !== null ? [res.data.properties[0]] : [],
                        clientID: (res.data.payPalIntegration.clientID),
                    });
                    setMaskData({
                        ...maskData,
                        clientID: mask(res.data.payPalIntegration.clientID),
                    });
                })
                .catch(err => console.log('err', err));

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
    }, [id]);
    const mask = (value) => {
        let maskedValue = "";
        for (let i = 0; i < value.length - 2; i++) {
            maskedValue += "*";
        }
        return maskedValue + value.substring(value.length - 2, value.length);
    }

    const handleNameChange = e => {
        e.persist();
        setInputData({ ...inputData, Name: e.target.value });
    };

    const handleApiKeyChange = e => {
        e.persist();
        setMaskData({ ...maskData, clientID: mask(e.target.value) });
        setInputData({ ...inputData, clientID: e.target.value });
    };
    const handleCheckChange = e => {
        if (e.target.checked) {
            setInputData({ ...inputData, Properties: [e.target.value] });
        }
        if (!e.target.checked) {
            setInputData({ ...inputData, Properties: [] });
        }
    };

    const handleSave = async () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${API_PAYPAL}/${id}?group_id=${getGroupID()}`,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggle();
                    setTimeout(() => {
                        LoadIntegrations();
                    }, 300);
                }
            });
        } else {
            AxiosAPI({
                method: 'post',
                url: API_PAYPAL,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    toggle();
                    setTimeout(() => {
                        LoadIntegrations();
                    }, 300);
                }
            });
        }
    };    
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>Add Intregation</h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup>
                                        <Label>Intregation Name</Label>
                                        <Input
                                            type="text"
                                            name="IntregationName"
                                            onChange={handleNameChange}
                                            placeholder="Intregation Name"
                                            defaultValue={inputData.Name}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Client Id</Label>
                                        <Input
                                            type="text"
                                            name="clientID"
                                            onChange={handleApiKeyChange}
                                            placeholder="Client Id"
                                            defaultValue={maskData.clientID}
                                        />
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <div className='integration-property text-start'>
                                            <div className='row' style={{ textAlign: 'left' }}>
                                                {property.map((p, index) => {
                                                    return (
                                                        <div className='col-md-6'>
                                                            <CustomInput
                                                                key={p.id}
                                                                type="radio"
                                                                id={index}
                                                                label={p.name}
                                                                value={p.id}
                                                                name="property"
                                                                checked={p.id === inputData.Properties[0] ? true : false}
                                                                onChange={handleCheckChange}
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    {id === undefined ? (<Button color="primary" size="xs" onClick={handleSave}>
                                        Create New Intregation
                                    </Button>) : (<Button color="primary" size="xs" onClick={handleSave}>
                                        Update Intregation
                                    </Button>)}
                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}